import { Injectable } from '@angular/core';
import { TiposCreditos, CreditosKeys } from './helpers.service';

@Injectable()
export class DatesHelpersService {
    
    public dateToString(jsonDate: any){
        if(!jsonDate){
            return '';
        }

        let month = (('0' + jsonDate.month).slice(-2));
        let day = (('0' + jsonDate.day).slice(-2));
        return `${jsonDate.year}-${month}-${day} 00:00:00`;
    }

    public dateToObj(laravelDate: any){
        if(!laravelDate){
            return {};
        }

        var fecha = new Date(laravelDate); 
        return { year: fecha.getFullYear(), month: (fecha.getMonth()+1), day: fecha.getDate()};
    }

    public getMonthDate(){
        let now = new Date();
        let defaultFechaFin =  now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + getLastDayOfMonth(now.getFullYear(), now.getMonth());
        
        let startDate = new Date();
        startDate.setDate(1);
        let defaultFechaInicio =  startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate();
    
        let defaultDates = {
            fechaInicio: defaultFechaInicio,
            fechaFin: defaultFechaFin
        }

        return defaultDates;
    }

}

function getLastDayOfMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}


// WEBPACK FOOTER //
// ./src/app/services/tools/dates-helpers.service.ts